import { render } from "./guide-category.vue?vue&type=template&id=f148768c&scoped=true"
import script from "./guide-category.vue?vue&type=script&lang=js"
export * from "./guide-category.vue?vue&type=script&lang=js"

import "./guide-category.vue?vue&type=style&index=0&id=f148768c&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\ahuview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f148768c"]])

export default __exports__